import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=59b90e35&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=59b90e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b90e35",
  null
  
)

export default component.exports